interface Props {
  size?: number;
  color?: string;
  rays?: number;
  rayLen?: number;
  className?: string;
}

export function SunMark({
  size = 32,
  color = '#8C534E',
  rays = 12,
  rayLen,
  className,
}: Props) {
  const r = size / 2;
  const cx = r;
  const cy = r;
  const len = rayLen ?? size * 0.18;
  const disk = r - len - 1;
  const rayArr = Array.from({ length: rays });
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      aria-hidden="true"
    >
      <g stroke={color} strokeWidth={Math.max(1.2, size * 0.05)} strokeLinecap="round">
        {rayArr.map((_, i) => {
          const a = (i / rays) * Math.PI * 2;
          const x1 = cx + Math.cos(a) * (disk + 2);
          const y1 = cy + Math.sin(a) * (disk + 2);
          const x2 = cx + Math.cos(a) * (disk + len);
          const y2 = cy + Math.sin(a) * (disk + len);
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>
      <circle cx={cx} cy={cy} r={disk} fill={color} />
    </svg>
  );
}
